module.exports = __webpack_public_path__ + "static/media/p2-tip-box.aed32194.svg";